export default __webpack_public_path__ + "static/media/aj1.4e51357f.png";